import { Box, HStack, Image, Text } from '@chakra-ui/react';

interface IIconButton {
  iconPath: string;
  text: string;
  onClickHandler: () => void;
}

function IconButton(props: IIconButton) {
  return (
    <Box
      as="button"
      width={'full'}
      height="50px"
      transition="all 0.2s cubic-bezier(.08,.52,.52,1)"
      borderRadius="4px"
      fontSize="18px"
      fontWeight="semibold"
      bgColor="black"
      color="white"
      _active={{
        transform: 'scale(0.98)',
      }}
      onClick={props.onClickHandler}>
      <HStack w={'full'} h={'full'} justifyContent={'center'} spacing={'10px'}>
        <Image src={props.iconPath} />
        <Text>{props.text}</Text>
      </HStack>
    </Box>
  );
}

export default IconButton;
